import { createElementVNode as _createElementVNode, mergeProps as _mergeProps, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/bp-logo-full@2x.png'


const _withScopeId = n => (_pushScopeId("data-v-bdb82d14"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col items-center justify-center h-full" }
const _hoisted_2 = { class: "login-box w-full sm:w-6/12 lg:w-3/12 xl:w-1/5" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex basis-full" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Buen Provecho Logo",
    class: "h-[60px] mb-8"
  })
], -1))
const _hoisted_4 = { class: "flex basis-full w-full" }
const _hoisted_5 = { class: "flex grow basis-full flex-col mb-3" }
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = { class: "flex grow basis-full flex-col mb-3" }
const _hoisted_8 = ["placeholder"]
const _hoisted_9 = { class: "flex basis-full w-full" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "flex basis-full text-sm items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tz_input_error = _resolveComponent("tz-input-error")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_Form = _resolveComponent("Form")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_toast = _resolveComponent("ion-toast")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, { class: "login-bg flex flex-col items-center justify-center login" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_Form, {
                  class: "w-full",
                  onSubmit: _ctx.login
                }, {
                  default: _withCtx(({meta}) => [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_Field, {
                        name: "email",
                        modelValue: _ctx.form.email,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.email) = $event)),
                        rules: "required|email",
                        placeholder: _ctx.$t('EMAIL'),
                        class: "bg-white mb-3 inline-flex grow px-2 py-3 rounded"
                      }, {
                        default: _withCtx(({ field, errors }) => [
                          _createElementVNode("input", _mergeProps(field, {
                            type: "email",
                            placeholder: _ctx.$t('EMAIL'),
                            class: "tz-standard-input border ion-color-gray-light-border"
                          }), null, 16, _hoisted_6),
                          _createVNode(_component_tz_input_error, {
                            errors: errors,
                            name: "email"
                          }, null, 8, ["errors"])
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"])
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_Field, {
                        name: "password",
                        modelValue: _ctx.form.password,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.password) = $event)),
                        rules: "required",
                        placeholder: _ctx.$t('PASSWORD')
                      }, {
                        default: _withCtx(({ field, errors }) => [
                          _createElementVNode("input", _mergeProps(field, {
                            class: "tz-standard-input border ion-color-gray-light-border capitalize",
                            type: "password",
                            placeholder: _ctx.$t('PASSWORD')
                          }), null, 16, _hoisted_8),
                          _createVNode(_component_tz_input_error, {
                            errors: errors,
                            name: "email"
                          }, null, 8, ["errors"])
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"])
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_ion_button, {
                        class: "rounded-md shadow-none mb-3 w-full capitalize",
                        color: "bp-orange",
                        type: "submit",
                        disabled: !meta.valid || _ctx.loading
                      }, {
                        default: _withCtx(() => [
                          (_ctx.loading)
                            ? (_openBlock(), _createBlock(_component_ion_spinner, { key: 0 }))
                            : _createCommentVNode("", true),
                          (!_ctx.loading)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.$t('SIGN_IN')), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["disabled"])
                    ])
                  ]),
                  _: 1
                }, 8, ["onSubmit"])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_ion_text, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('DONT_HAVE_AN_ACCOUNT')) + " ", 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_button, {
                  fill: "clear",
                  color: "bp-orange",
                  size: "small",
                  class: "p-0 capitalize",
                  "router-link": "/sign-up"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('SIGN_UP')), 1)
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _createVNode(_component_ion_toast, {
            "is-open": _ctx.messageToastOpen,
            message: _ctx.toastMessage,
            duration: 3000,
            buttons: _ctx.toastButtons,
            onDidDismiss: _cache[2] || (_cache[2] = ($event: any) => (_ctx.messageToastClosed()))
          }, null, 8, ["is-open", "message", "buttons"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}